<template>
  <div>
    <b-card no-body class="card-transparent-background">
      <b-card-header class="p-0">
        <b-card-title class="card-title-form-steps-garden-help">
          Accounts Registeration
        </b-card-title>
        <b-card-sub-title class="card-subtitle-form-steps-garden-help">
          Please provide us with your details to start working now
        </b-card-sub-title>
      </b-card-header>
      <b-card-body class="p-0">
        <b-card no-body>
          <b-card-body class="px-2 py-4">
            <div class="container">
              <b-row>
                <b-col>
                  <b-form-group class="
                        form-group-radio-group form-group-radio-garden-help
                      " label="Do you want to add staff" v-slot="{ ariaDescribedby }"
                    label-class="form-label-garden-help text-left mb-2" :add_staff="add_staff">
                    <b-form-radio-group id="add_staff" v-model="_add_staff" :aria-describedby="ariaDescribedby"
                      name="add_staff" stacked>
                      <b-form-radio class="
                            form-control form-control-garden-help
                            radio-input-container
                            mb-1
                          " v-model="add_staff" :aria-describedby="ariaDescribedby" name="add_staff"
                        value="1">Yes</b-form-radio>
                      <b-form-radio class="
                            form-control form-control-garden-help
                            radio-input-container
                            mb-1
                          " v-model="_add_staff" :aria-describedby="ariaDescribedby" name="add_staff"
                        value="0">No</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-card-body>
        </b-card>
      </b-card-body>
    </b-card>
    <b-card no-body class="card-transparent-background my-0" v-if="_add_staff == 1">
      <b-card-header class="p-0">
        <b-card-title class="card-title-form-steps-garden-help">
          Staff Details
        </b-card-title>
      </b-card-header>
      <b-card-body class="p-0">
        <b-card no-body class="py-2 px-3" v-for="(staff, index) in  staff_list " :key="index">
          <b-card-header class="pl-0 pr-1">
            <b-row>
              <b-col cols="10" class="pl-0">
                <b-card-title class="card-title-garden-help-default pb-0">
                  Staff {{ index + 1 }}
                </b-card-title>
              </b-col>
              <b-col cols="2" class="d-flex justify-content-end">
                <b-button type="button" variant="action-garden-help" v-if="index != 0" @click="clickDeleteStaff(index)">
                  <img src="@/assets/images/garden-help/delete-icon.png" />
                </b-button>
              </b-col>
            </b-row>
          </b-card-header>
          <b-card-body class="pt-0 pb-2 px-1">
            <StaffDataComponent :type="type" :first_name.sync="staff.first_name"
              :invalid_first_name="staff.invalid_first_name" :last_name.sync="staff.last_name"
              :invalid_last_name="staff.invalid_last_name" :email.sync="staff.email" :invalid_email="staff.invalid_email"
              :invalid_correct_email="staff.invalid_correct_email" :phone_number.sync="staff.phone"
              :invalid_phone_number="staff.invalid_phone" :experience_level.sync="staff.experience_level"
              :invalid_experience_level="staff.invalid_experience_level" :service.sync="staff.services"
              :invalid_service="staff.invalid_services" :address.sync="staff.address"
              :longitude.sync="staff.longitude" :latitude.sync="staff.latitude"
              :invalid_address="staff.invalid_address"
              :invalid_address_longitude="staff.invalid_address_longitude"
              :invalid_address_latitude="staff.invalid_address_latitude" :country.sync="staff.country"
              :county.sync="staff.county" :city.sync="staff.city" :country_code="staff.country_code" />

            </b-card-body>
        </b-card>
        <b-button variant="garden-help-primary-link" class="btn-bumblebee btn-garden-help pl-0" @click="clickAddStaff">
          <span class="btn-icon"><font-awesome-icon icon="fa-solid fa-circle-plus" />
          </span>
          Add another staff
        </b-button>
      </b-card-body>
    </b-card>
  </div>
</template>
          
<script>
import StaffDataComponent from './StaffDataComponent.vue';
export default {
  name: "StaffRegistrations",
  components: { StaffDataComponent },
  props: ["type", "is_company", "add_staff", "staff_list", "country", "country_code"],

  data() {
    return {};
  },
  mounted() { },

  computed: {
    _add_staff: {
      get() {
        return this.add_staff;
      },
      set(value) {
        this.$emit("update:add_staff", value);
        if (value == 0) {
          this.staff_list = [
            {
              first_name: "",
              invalid_first_name: false,
              last_name: "",
              invalid_last_name: false,
              email: "",
              invalid_email: false,
              phone: "",
              invalid_phone: false,
              experience_level: "",
              invalid_experience_level: false,
              services: null,
              invalid_services: false,

              address: null,
              longitude: null,
              latitude: null,
              invalid_address: false,
              invalid_address_longitude: false,
              invalid_address_latitude: false,
              country: null,
              county: this.country,
              city: null,
              country_code: this.country_code
            },
          ];
        }
      },
    },
  },
  methods: {
    clickAddStaff() {
      this.staff_list.push({
        first_name: "",
        invalid_first_name: false,
        last_name: "",
        invalid_last_name: false,
        email: "",
        invalid_email: false,
        phone: "",
        invalid_phone: false,
        experience_level: "",
        invalid_experience_level: false,
        services: null,
        invalid_services: false,

        address: null,
        longitude: null,
        latitude: null,
        invalid_address: false,
        invalid_address_longitude: false,
        invalid_address_latitude: false,
        country: null,
        county: this.country,
        city: null,
        country_code: this.country_code
      });
    },
    clickDeleteStaff(index) {
      this.staff_list.splice(index, 1);
    },
  },
};
</script>
  


// WEBPACK FOOTER //
// src/projects/garden_help/contractor/profile_details_components/StaffRegistrations.vue